var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.682129 0.682373H18.8603V1.97077H0.682129V0.682373Z",
    fill: "#002C79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.744868 10.8932H12.989V12.1085H0.744868V10.8932ZM0.682129 5.97076H18.8186V7.18603H0.682129V5.97076ZM16.4366 10.6791L16.4366 13.9543L19.7118 13.9543V15.1696L16.4366 15.1695L16.4366 18.4448H15.2213V15.1695L11.9461 15.1696V13.9543L15.2213 13.9543V10.6791H16.4366Z",
    fill: "#002C79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHider);
export default __webpack_public_path__ + "static/media/hider.5c9d1ec260b91fed949f92abd6eef7b3.svg";
export { ForwardRef as ReactComponent };